import React from "react";
import PropTypes from "prop-types";
import Slide from "@material-ui/core/Slide";
import { IconButton, Typography } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Close } from "@material-ui/icons";
import useScreen from "../../../hooks/useScreen";

const AlertHandler = ({ alerts }) => {
  // const [open, setOpen] = useState(false);
  const { desktop } = useScreen();

  return alerts.map((alert, i) => (
    <Slide
      key={i}
      direction="left"
      in={alert.open}
      mountOnEnter
      unmountOnExit
      style={{
        position: "absolute",
        right: desktop ? 50 : 10,
        top: 10 + (i + 1) * 100,
        zIndex: 10000,
        maxWidth: desktop ? "450px" : "330px",
      }}
    >
      <Alert
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={alert.clearListener}
          >
            <Close fontSize="inherit" />
          </IconButton>
        }
        severity={alert.severity}
      >
        <AlertTitle>
          <Typography color="secondary" variant="body1">
            <b>{alert.title}</b>
          </Typography>
        </AlertTitle>
        <Typography color="secondary" variant="body1">
          {Array.isArray(alert.text)
            ? alert.text.map((txt, i) => (
                <React.Fragment key={i}>
                  <span>{txt}</span> <br />
                </React.Fragment>
              ))
            : alert.text}
        </Typography>
      </Alert>
    </Slide>
  ));
};

AlertHandler.propTypes = {
  alerts: PropTypes.array,
};

AlertHandler.defaultProps = {
  alerts: [],
};

export default AlertHandler;
